import createApiClient from "./api";

const client = createApiClient();

export const participantApi = {
  getProfile: () => client.get("/auth/profile").then(({ data }) => data),

  getActionPlans: () =>
    client.get("/participants/action-plans").then(({ data }) => data),

  getLearningPaths: () =>
    client.get("/participants/learning-paths").then(({ data }) => data),

  getLearningPathDetail: ({ trackerId, learningPathId }) =>
    client
      .get(`/participants/${trackerId}/learning-paths/${learningPathId}`)
      .then(({ data }) => data),

  getLearningPathCourseModules: ({ trackerId, learningPathId, courseId }) =>
    client
      .get(`/participants/${trackerId}/learning-paths/${learningPathId}/courses/${courseId}`)
      .then(({ data }) => data),

  startModule: ({ trackerId, learningPathId, courseId, moduleId, payload = {} }) =>
    client
      .post(
        `/participants/${trackerId}/learning-paths/${learningPathId}/courses/${courseId}/modules/${moduleId}`,
        payload
      )
      .then(({ data }) => data),

  saveModuleProgress: (payload) =>
    client.post("/participants/save-module-progress", payload).then(({ data }) => data),

  submitGoal: (payload) =>
    client.post("/participants/goals", payload).then(({ data }) => data),

  submitAchievement: (payload) =>
    client.post("/participants/achievements", payload).then(({ data }) => data),
};
